import React, { useState } from 'react'
import Title from '../../../components/Title/Title';
import { Col, Container, Row } from 'react-bootstrap';
import EventCard from '../../../components/EventCard';
import Button from '../../../components/Button';
import SectionHeader from '../../../components/SectionHeader';

function Usp(props) {



    return (
        <>

            <div className="usp">

            </div>
            <div className="container-fluid2 bg2 ">
                <Title options={{ "title": "Why Choose EFH | Our USP for ICSE & CBSE Tuition", "description": "Discover what makes EFH unique: personalised online Computer Science tuition for ICSE and CBSE students of Class 9-12 with expert mentors.", "image": "", "url": "" }} />

                <div className="container sectionheader ">


                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card p-3'>
                                <h2 className="text-center fw-bold mb-4" style={{ fontSize: "250%" , lineHeight: "2" }}>Our <span className="text-primary">USP</span></h2>
                                <ol className="" style={{ fontSize: "130%" , lineHeight: "2" }}>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Experienced teacher with more than 20 years of teaching</span> computer science to over 2000 students.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Offline recorded lecture videos available to students</span> anytime, anywhere through the EFH app and website.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Multi-lingual videos</span> in all Indian regional languages so that no student is left out.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Personalised learning</span> for each student, through their own profile on the EFH portal to track performance, grades, completion of quizzes and assignments, and lots more.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">End-of-module quizzes</span> with 10-15 questions after every chapter, to ensure deep learning and understanding.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Chat support 24/7</span> integrated with ChatGPT that ensures students get answers to their queries within five minutes.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Interactive mascot</span> featured in every video who serves as a helper, guide and support for students and first timers.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Students learn at their own pace</span> through pre-recorded videos that can be saved and accessed later.
                                    </li>
                                    <li>
                                        <span className="fw-bold text-primary">Use of Lightboard for teaching</span> transforms recorded lectures into dynamic and captivating classroom experiences.
                                    </li>
                                </ol>



                            </div>
                        </div>
                    </div>




                     


                </div>
            </div>
        </>
    );
};


export default Usp;
